module.exports = __webpack_public_path__ + "c839a887d9b452a9ba27a1d370670098.fbx";